module.exports = __webpack_public_path__ + "static/media/logo.288b6de3.jpg";